// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/charging-faults.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/charging-faults/charging-faults.js';

mount([g0]);
